import Root from "components/Root.vue";
new Root().$mount("#designer-app-root");
